// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartPurchaseAttachment } from './part-purchase-attachment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartPurchase extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get enteredAmount() {
        return this.inStock !== 0 ? this.inStock + this.quantity : 0;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  allocated!: number;
  createdBy?: string;
  date?: Date;
  inStock!: number;
  partId!: number;
  price!: number;
  projectedInventory!: number;
  quantity!: number;
  reason?: string;
  part!: Part;
  partPurchaseAttachments!: PartPurchaseAttachment[];
}

